import { host } from "config/api.config";
import { ListRoomReservationFilter } from "model/roomReservation/ListRoomReservationFilter.model"
import { ListRoomReservationResponse } from "model/roomReservation/ListRoomReservationResponse.model"
import { useHTTPClient } from "services/httpClient.service"

const url = `${host}/room-reservation`

export function useGetRoomReservationsApi() {
    const {data, loading, error, get} = useHTTPClient<ListRoomReservationResponse[]>(url)

    function getApi({companyUsername, buildingIds, areaIds, roomIds, startDate, endDate}: ListRoomReservationFilter) {
        return get({
            _url: url,
            params: {
                companyUsername: companyUsername,
                buildingIds: buildingIds,
                areaIds: areaIds,
                roomIds: roomIds,
                startDate: startDate?.toISOString(),
                endDate: endDate?.toISOString()
            }
        })
    }

    return {
        loading,
        error,
        get: getApi,
        data
    }
}

export function useCreateRoomReservationApi() {
    const {post, loading, error} = useHTTPClient<void>(url)

    function postApi(data: any) {
        return post({
            _url: url,
            data: data
        })
    }

    return {
        loading,
        error,
        create: postApi
    }
}

export function useUpdateRoomReservationApi() {
    const {put, loading, error} = useHTTPClient<void>(url)

    function putApi(id: string, data: any) {
        return put({
            _url: `${url}/${id}`,
            data: data
        })
    }

    return {
        loading,
        error,
        update: putApi
    }
}

export function useDeleteRoomReservationApi() {
    const {_delete, loading, error} = useHTTPClient<void>(url)

    function deleteApi(id: string) {
        return _delete({
            _url: `${url}/${id}`
        })
    }

    return {
        loading,
        error,
        delete: deleteApi
    }
}

export function useGetRoomReservationApi() {
    const {get, loading, error, data} = useHTTPClient<any>(url)

    function getApi(id: string) {
        return get({
            _url: `${url}/${id}`
        })
    }

    return {
        loading,
        error,
        data,
        get: getApi
    }
}
